// Cobro programado por cuenta (#1809): lo que el médico hace con el aviso (para el monitoreo del
// admin) y la configuración que maneja Sebastián desde /admin/users. Contrato:
// .claude/progress/1809-aviso-pago/CONTRATO.md.
import getClient from "./get-client";

const client = getClient();

// Telemetría del aviso: nunca bloqueante. Si falla, el médico sigue igual.
export const enviarEventoAviso = async (evento) => {
  try {
    await client.post("/api/billing/me/aviso-pago/", { evento });
  } catch {
    /* el monitoreo no puede romper el pago */
  }
};

// "Estoy de turno": sigue hasta las próximas 9:00 (con menos de 3 h, las del día después), una vez por ciclo (decisión de Sebastián 27-oct).
// Esta sí devuelve el error, el gate muestra el motivo.
export const pedirTurno = async () => {
  const res = await client.post("/api/billing/me/aviso-pago/", { evento: "turno" });
  return res.data;
};

export const getAvisoAdmin = async (userId) => {
  const res = await client.get(`/api/billing/admin/users/${userId}/aviso-pago/`);
  return res.data;
};

export const patchAvisoAdmin = async (userId, cambios) => {
  const res = await client.patch(`/api/billing/admin/users/${userId}/aviso-pago/`, cambios);
  return res.data;
};

export const darPase = async (userId, dias, motivo) => {
  const res = await client.post(`/api/billing/admin/users/${userId}/pase/`, { dias, motivo });
  return res.data;
};

export const linkDePago = async (userId) => {
  const res = await client.post(`/api/billing/admin/users/${userId}/flow/inscripcion/`);
  return res.data;
};
